import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormikErrors } from 'formik';
import { isErrorInTab } from '../modals/DevicesAndRoutingModal';

const useStyles = makeStyles(() => ({
  tabContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
  },
  tabIcon: {
    marginRight: 15,
  },
  reset: {
    margin: 0,
    padding: 0,
    alignContent: 'center',
    '.Mui-selected &': {
      fontWeight: 900,
    },
  },
  warningIcon: {
    color: 'orange',
  },
}));

const TabLabel = (props: {
  index: any;
  tabToFields: any;
  formik: any;
  tabItem: any;
  title?:
    | string
    | string[]
    | FormikErrors<any>
    | FormikErrors<any>[]
    | undefined;
}) => {
  const { tabItem, formik, index, tabToFields, title } = props;
  const classes = useStyles();
  return (
    <div className={classes.tabContainer}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <tabItem.icon className={classes.tabIcon} />
        <p className={classes.reset}>{tabItem.title}</p>
      </div>
      <div>
        {Object.keys(formik.touched).length !== 0 &&
          formik.dirty &&
          isErrorInTab(index, formik.errors, tabToFields) && (
            <Tooltip
              title={
                title ||
                `This tab contains form input errors, make a change and save to show errors.`
              }
            >
              <WarningIcon className={classes.warningIcon} />
            </Tooltip>
          )}
      </div>
    </div>
  );
};
export default TabLabel;
